import type { FaireProductEntity } from "../../entity_types/product";

export const p_6yeemfcaq8: FaireProductEntity = {
  token: "p_6yeemfcaq8",
  type: "product",
  name: "20mm Mix Crystal Hearts Nice Quality Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/f29d964b21c8cc2bc1f5efa1907e53f224a8d86d0553c50b8c0e75a0cdd553b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/274632748997dba7dd8901f15c81f3feb74a99a7b7d2b9c4184b876ca92512d4.jpeg",
    "https://cdn.faire.com/fastly/6c28999554c58e1ca780007a9b24e41688f00720c03bd78a111b820e1b85f8f4.jpeg",
    "https://cdn.faire.com/fastly/a4138179529a66886b19a3be790999ba3c8181fd4f504cbfacb5adde9ed52b1c.jpeg",
    "https://cdn.faire.com/fastly/0f242c338467bdb642d42bccedaf8e0cdec1dd6a71aae6d34565ab95baf7e93a.jpeg",
    "https://cdn.faire.com/fastly/4c8fab3f1a3833b5bf5ba9ba4f4a39261f39657f6f606a1997c75eaf4a3dcfc0.jpeg",
    "https://cdn.faire.com/fastly/3c9fb0391ad4fbc53152bfc37c9a08e29310602a77baac68bf3e84f3539a48ca.jpeg",
    "https://cdn.faire.com/fastly/d8befcb4111f8c74ea3ece334b8ad3fdf41030096a781d2eb3f4fcc8eb3937a6.jpeg",
    "https://cdn.faire.com/fastly/39a1ef1bf260b30d08487f7e0ecdc54a0a7bbc552600b61d9a138b09bc381937.jpeg",
  ],
  priceDollars: 1.21,
  description:
    "Wholesale Lot 30 pcs 20mm Mixed Crystal Hearts. You will receive 1 Aventurine, 1 Amethyst, 12 Rose Quartz, 2 Labradorite, 10 Clear Quartz, 1 Red Jasper, 1 Que Sera, 1 Blue Aventurine, and 1 Howlite. Condition is New\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 2.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:44.188Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
